var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPercent = function SvgPercent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 96,
    height: 96,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#1E1E1E",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: "M60 36 36 60m0-24h.04M60 60h.04M15.4 34.48A16 16 0 0 1 34.52 15.4a16 16 0 0 1 26.96 0A16 16 0 0 1 80.6 34.52a16 16 0 0 1 0 26.96A16 16 0 0 1 61.52 80.6a16 16 0 0 1-27 0A16 16 0 0 1 15.4 61.52a16 16 0 0 1 0-27.04"
  })));
};
export default SvgPercent;